import { useBooleanFlag } from "@apac/feature-flags";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  CreditHistoryDialog,
  CreditHistorySummary,
  MerchandisingAlert,
} from "@hsbc/portal";
import { FeatureFlagNames, getFaqLink } from "@hsbc/utilities";
import styles from "./styles.module.scss";

const HISTORY_ITEMS_TO_DISPLAY = 3;

export const Credits = () => {
  const { t, language } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "WalletCredits");
  const showMerchandising = useBooleanFlag(
    FeatureFlagNames.SHOW_WALLET_CREDIT_MERCHANDISING_BANNER
  );

  return (
    <div className={block}>
      {/* This will break the page because useMerchandisingAlert added dependency on checkout state
      and will through NPE here, can fix when needed */}
      {showMerchandising && <MerchandisingAlert />}
      <CreditHistorySummary
        maxItemsToDisplay={HISTORY_ITEMS_TO_DISPLAY}
        className={cn("history-summary")}
      >
        <CreditHistoryDialog>
          <button className={cn("open-dialog-button")}>
            {t("wallet.credits.viewActivity")}
          </button>
        </CreditHistoryDialog>
      </CreditHistorySummary>

      <span>{t("wallet.credits.learnMoreLabel")}</span>

      <a href={getFaqLink(language)} target="_blank" rel="noreferrer">
        {t("wallet.credits.faqButton")}
      </a>
    </div>
  );
};
